import { AnimatePresence, motion } from 'framer-motion'

import { cn } from '../../lib/utils'
import { motionTransitions } from '../../lib/motion'

const buttonContentVariants = {
  initial: {
    y: 32,
    opacity: 0,
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: motionTransitions.card,
  },
  exit: {
    y: -32,
    opacity: 0,
    transition: motionTransitions.quick,
  },
}

export function AnimatedStateButton({ state, states, className, style, onClick }) {
  const currentState = states[state] || states.idle

  return (
    <button
      type='button'
      onClick={onClick}
      style={style}
      aria-busy={state === 'loading'}
      className={cn(
        'relative h-11 min-h-11 w-full min-w-0 shrink-0 cursor-pointer select-none overflow-hidden rounded-full font-IBM text-sm font-semibold leading-5 transition-colors duration-200 min-[360px]:flex-1',
        className,
        currentState.buttonClassName,
      )}
    >
      <AnimatePresence initial={false} mode='popLayout'>
        <motion.span
          key={state}
          className={cn(
            'absolute inset-0 flex items-center justify-center',
            currentState.className,
          )}
          variants={buttonContentVariants}
          initial='initial'
          animate='animate'
          exit='exit'
        >
          {currentState.icon}
          <span className='whitespace-nowrap'>{currentState.label}</span>
        </motion.span>
      </AnimatePresence>
    </button>
  )
}
